module.exports = __webpack_public_path__ + "img/wrapbg2.b0ba297d.png";